import React from 'react';

import './LoadingSpinner.scss';

const NUMBER_OF_CIRCLES = 8;

export default class LoadingSpinner extends React.PureComponent {
    constructor(props) {
        super();

        this.baseCls = 'component-Elements-LoadingSpinner';
    }

    renderSpinner = () => {
        const output = [];
        const { baseCls } = this;
        for (let i = 0; i < NUMBER_OF_CIRCLES; i += 1) {
            output.push(
                <div className={`${baseCls}__item`} key={`spinner-${i}`} />
            );
        }
        return output;
    };

    render() {
        return <div className={this.baseCls}>{this.renderSpinner()}</div>;
    }
}
